import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { HallPass } from '../../../../../models/HallPass';
import * as toLocationActions from '../actions';
import { IToLocationState } from '../states';

export const adapter: EntityAdapter<HallPass> = createEntityAdapter<HallPass>();

export const toLocationPassesInitialState: IToLocationState = adapter.getInitialState({
	loading: false,
	loaded: false,
});

const reducer = createReducer(
	toLocationPassesInitialState,
	on(toLocationActions.getToLocationPasses, (state) => ({ ...state, loading: true, loaded: false })),
	on(toLocationActions.getToLocationPassesSuccess, (state, { toLocationPasses }) => {
		return adapter.setAll(toLocationPasses, { ...state, loading: false, loaded: true });
	})
);

export function toLocationPassesReducer(state: any | undefined, action: Action) {
	return reducer(state, action);
}
